import { IS_LOADING } from "types/actions/isLoading"

const isLoadingInitialState = {
  loading: false
}

export default (state = isLoadingInitialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return { loading: action.loading }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/isLoading.js